import { getProductId } from '~/components/context';

const track = (label: string, properties?: Record<string, any>) => {
  const win = window as any;
  if (win && win.analytics) {
    const productId = getProductId();
    const payload = properties ? { ...properties, productId } : { productId };
    win.analytics.track(label, payload);
  }
};

export default track;
